import React from "react"
import HeadingM from "../../components/shared/HeadingM"
import Schedule from "../../components/shared/program/Schedule"

const program = () => {
  const items = [
    {
      day: "月",
      contents: "リズム、音楽",
    },
    {
      day: "火",
      contents: "個別活動 / 集団活動",
    },
    {
      day: "水",
      contents: "協同遊び",
    },
    {
      day: "木",
      contents: "運動",
    },
    {
      day: "金",
      contents: "個別活動 / リズム、音楽",
    },
    { day: "土",
      contents: "外出、課外体験活動(買い物、公園、各施設等の体験)" 
    },
  ]
  return (
    <div>
      <HeadingM title="スケジュール" target="sutea" />
      <Schedule items={items} target="sutea" />
      <p>※各月によって曜日と活動入れ替わり有</p>
    </div>
  )
}

export default program
